import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=b51d3fc8&scoped=true"
import script from "./LayoutFooter.vue?vue&type=script&lang=js"
export * from "./LayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=b51d3fc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d3fc8",
  null
  
)

export default component.exports